import React from 'react';
import { motion } from 'framer-motion';

export default function Hero({ onBook }) {
  return (
    <section id="beranda" className="relative pt-32 pb-20 lg:pt-48 lg:pb-32 overflow-hidden bg-white">
      <div className="absolute inset-0 opacity-[0.03] pointer-events-none"
        style={{ backgroundImage: 'radial-gradient(#0D1B2A 1px, transparent 1px)', backgroundSize: '40px 40px' }}>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-8 items-center">

          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="max-w-2xl"
          >
            {/* Premium Brand Badge */}
            <div className="inline-flex items-center gap-2 md:gap-4 bg-gradient-to-r from-navy to-[#1a2c42] p-1 md:p-1.5 pr-3 md:pr-6 rounded-full mb-8 shadow-xl shadow-navy/10 transform hover:scale-105 hover:-translate-y-1 transition-all duration-300 border border-white/10 max-w-full">
              <div className="bg-gradient-to-r from-orange to-[#ff7e4f] text-white text-[10px] md:text-xs font-black px-3 md:px-4 py-1.5 md:py-2 rounded-full uppercase tracking-wide md:tracking-widest shadow-inner whitespace-nowrap">
                GARUDA EKSPRESS
              </div>
              <div className="text-white text-[11px] md:text-base font-semibold tracking-wide md:tracking-wider whitespace-nowrap truncate">
                Logistik Terpercaya
              </div>
            </div>

            <h1 className="font-heading text-4xl md:text-5xl lg:text-6xl font-bold text-navy leading-[1.2] mb-6 tracking-tight">
              Pengiriman Cepat, Aman, dan Terpercaya ke Seluruh Indonesia.
            </h1>
            <p className="text-lg text-gray-600 mb-8 leading-relaxed">
              Solusi logistik modern untuk bisnis dan personal. Kami memastikan paket Anda tiba tepat waktu dengan layanan kelas satu.
            </p>

            <div className="flex flex-col sm:flex-row gap-4">
              <button
                onClick={() => onBook('Garuda Reguler (G-Reg)')}
                className="font-heading inline-flex justify-center items-center bg-orange hover:bg-[#d94f1e] text-white px-8 py-4 rounded-xl font-semibold transition-all transform hover:-translate-y-1 shadow-lg shadow-orange/30"
              >
                Pesan Layanan Sekarang
              </button>
              <button className="font-heading inline-flex justify-center items-center bg-transparent border-2 border-navy text-navy hover:bg-navy hover:text-white px-8 py-4 rounded-xl font-semibold transition-all">
                Lacak Paket Anda
              </button>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.7, delay: 0.2 }}
            className="relative"
          >
            <div className="absolute inset-0 bg-gradient-to-tr from-orange/20 to-navy/5 rounded-[2rem] transform rotate-3 scale-105 -z-10 transition-transform duration-700 hover:rotate-6"></div>
            <img
              src="/images/hero-logistic.jpg"
              alt="Armada Logistik Modern"
              className="rounded-[2rem] shadow-2xl object-cover w-full h-[400px] lg:h-[520px] ring-1 ring-black/5"
            />
          </motion.div>

        </div>
      </div>
    </section>
  );
}